module.exports = __webpack_public_path__ + "static/media/tfs6.ab3ba86e.jpg";